// extracted by mini-css-extract-plugin
export default {"container":"contact-list-content_container__iDnzK"};